<template>
    <div id="cardRateHeaderList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Rate Rule & Header List</div>
                        <!-- <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
                        <div class="btn-groups pull-right">
                            <template v-if="addCardRate==true">
                                <router-link title="Add Card Rate Header"  class="btn btn-primary" v-bind:to="{name: 'CardRateHeaderCreate'}" > <i class="fp-add"> </i> Add</router-link>
                            </template>

                        </div>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-ach-detail">
                        <data-table-filter-config :moduleName="'cardRateHeaderList'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="bg-white data-table">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'cardRateHeaderList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listCardRateHeaderTable"
                                    mode="remote"
                                    title="Card Rate Header"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: false,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='align-center'>
                                                <template>
                                                <router-link title="Update Card Rate Header" class="fp-edit mr-3" v-bind:to="{name: 'CardRateHeaderEdit',params:{id:props.row.id}}"></router-link>
                                                </template>
                                                <template>
                                                    <router-link title="Update Card Rate" class="fp-settings mr-3" v-bind:to="{name: 'CardRateConfiguration',params:{id:props.row.id},query:{'from':'header'}}"></router-link>
                                                </template>
                                                <template v-if="approveRate && props.row.status != 'Approved'">
                                                    <router-link title="Approve Card Rate" class="fp-receive-order mr-3" v-bind:to="{name: 'CardRateConfiguration',params:{id:props.row.id},query:{'from':'status'}}"></router-link>
                                                </template>
                                                <template v-if="props.row.map_type != 'All'">
                                                    <router-link  title="View Customer" class="fp-user mr-3"  v-bind:key="'action_view_scope' + key" v-bind:to="{name: 'CardRatesCustomerList',params:{id:props.row.id}}"></router-link>
                                                </template>

                                            </div>
                                            <div v-else-if="props.column.field == 'scope'">
                                                <template>
                                                <router-link  title="View Scope" class="color-blue"  v-bind:key="'action_view_scope' + key" v-bind:to="{name: 'CardRateConfigurationView',params:{id:props.row.id}}">{{props.row.scope}}</router-link>
                                              </template >
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>


                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from "././event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "CardRateHeaderList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Discount Rate List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Scope',
                    field: 'scope',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'Contract Type',
                    field: 'contract_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Contract Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'Effective Date',
                    field: 'effective_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Expiry Date',
                    field: 'expiry_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Expiry Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Expiry Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Pending','Approved', 'Reject'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Map Type',
                    field: 'map_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "map_type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['All','One', 'Multiple'],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },

            ],
            rows: [],
            totalRecords: 0,
            customer_class_value: false,
            loading:false,
            addCardRate:false,
            action:'list',
            approveRate:false
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'scope_header_list') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'scope_header_create') {
                            self.addCardRate = true;
                        }
                        if (permissions[i].name == 'can_approve_rate') {
                            self.approveRate = true;
                        }

                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadCustomerClass();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listCardRateHeaderTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                var data = self.$refs['listCardRateHeaderTable'].selectedRows;
                var selectedRows = [];

                for (var i = 0; i < data.length; i++) {
                    selectedRows.push(self.$refs['listCardRateHeaderTable'].selectedRows[i].id)
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action:self.action,
                    selectedRows:selectedRows
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/card-rate-header/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'get-card-rate-header-list')
                    }
                });
            },
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/CardRateHeaderList.vue